import { AlertService } from '../../services/alert.service';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { GlobalService } from '../../global.service';
import { ConstantesService } from '../../services/constantes.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private alertService: AlertService, private globalService: GlobalService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        if (sessionStorage.getItem('Token') && sessionStorage.getItem('expiracionToken')) {
            const expiracionToken: Date = new Date(Date.parse(sessionStorage.getItem('expiracionToken')));
            // logged in so return true
            if (expiracionToken >= new Date(Date.now()) && sessionStorage.getItem('Usuario') != null) {
                return this.validarRolUsuario(state);
            }
        }
        // not logged in so redirect to login page with the return url
        this.alertService.generateAlertError('Acceso Denegado, por favor ingrese a SIA3', 'Error');
        this.globalService.cerrarSesion();

        // this.router.navigate(['/not-found']);
        // cambiar para entrega
        const urlLogin = sessionStorage.getItem('urlLogin') ? sessionStorage.getItem('urlLogin') : 'http://www.google.com';
        window.location.href = urlLogin;
        return false;
    }

    validarRolUsuario(state: RouterStateSnapshot) {
        const url = (state.url == '/' || state.url == '/main/') ? '/main' : state.url.replace('/main/', '/');
        if (sessionStorage.getItem(ConstantesService.ROL_SESSION) && this.globalService.permisosUsuario.length > 0) {
            const menu = this.globalService.permisosUsuario.filter(opcion =>
                    opcion.nombreRolAsociado == sessionStorage.getItem(ConstantesService.ROL_SESSION_SIA3));
            return !!menu.find(menuOpcion => url.includes(menuOpcion.nombreObjeto));
        } else {
          this.router.navigate(['/rol']);
          return false;
        }
      }
}
